import { ReactNode } from 'react'
import Image from 'next/image'

import Button from 'shared/ui/Button/Button'
import FormattedText from 'shared/ui/FormattedText'

import {
  SectionCenterHeader,
  SectionWithPadding,
  StyledCustomPortableText
} from './styles'

import styles from './HowMakeOrderSection.module.scss'

interface HowMakeOrderSectionProps {
  header: string

  image: {
    src: string
    alt: string
  }
  cta: {
    text: string
    href: string
  }
  list: {
    number: number
    icon?: {
      src: string
      alt: string
    }
    content: string | ReactNode
  }[]

  subheader: string
  content: string | ReactNode
}
export default function HowMakeOrderSection({
  header,
  image,
  list,
  subheader,
  content,
  cta
}: HowMakeOrderSectionProps) {
  return (
    <SectionWithPadding $sizeTop='large' $sizeBottom='medium' $condensed>
      <SectionCenterHeader className={styles.header}>
        <FormattedText text={header} />
      </SectionCenterHeader>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            src={image.src}
            alt={image.alt}
            width={0}
            height={0}
            sizes='max-width: 768px) 100vw, 50vw'
          />
        </div>
        <div className={styles.content}>
          <ul className={styles.list}>
            {list.map(item => (
              <li key={item.number} className={styles.listItem}>
                <div className={styles.listItemNumber}>{item.number}</div>
                <div className={styles.listItemHeader}>
                  <div className={styles.listItemContent}>{item.content}</div>
                  {item.icon && (
                    <Image
                      className={styles.listItemIcon}
                      src={item.icon.src}
                      alt={item.icon.alt}
                      width={0}
                      height={0}
                      sizes='30px'
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
          <Button
            className={styles.button}
            variant='primary'
            size='large'
            fullWidth
          >
            {cta.text}
          </Button>
        </div>
      </div>
      <div className={styles.bottomContainer}>
        <SectionCenterHeader className={styles.header}>
          <FormattedText text={subheader} />
        </SectionCenterHeader>
        <StyledCustomPortableText className={styles.textContent}>
          {content}
        </StyledCustomPortableText>
      </div>
    </SectionWithPadding>
  )
}
